import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  SuccessToast,
  TrashIcon,
  deleteBrandTemplate,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const BrandTemplateDelete = ({
  modalIsOpen,
  closeModal,
  setLoading,
  refetch,
}: PropsModal & {
  modalIsOpen: number | null;
  setLoading: Dispatch<SetStateAction<boolean>>;
  refetch: () => void;
}) => {
  async function handleDelete() {
    if (!modalIsOpen) return;
    try {
      setLoading(true);

      const { data } = await deleteBrandTemplate(modalIsOpen);
      SuccessToast(data.message);
      setLoading(false);
      closeModal?.();
      refetch();
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={!!modalIsOpen} closeModal={closeModal} logo={false}>
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Brand Template?</H3>
      <P $mb="24">Are you sure you want to delete this brand template?</P>

      <Div $flex $gap="16px">
        <Button $selected $w="100%" onClick={() => handleDelete()}>
          Confirm
        </Button>
        <Button $selected $gray $w="100%" onClick={closeModal}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
